import React, { useEffect, useContext } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import Context from '../context/ContextStorefront';

const Cart = ({ location }) => {
    const { checkout, updateQuantityInCart, isCartOpen, setCartOpen } =
        useContext(Context);

    const { lineItems = [] } = checkout;

    useEffect(() => {
        if (isCartOpen) {
            const cartViewItems =
                lineItems.map((item, index) => ({
                    id: item.id,
                    product_id: item.id,
                    variant_id: item.variant?.id || '',
                    name: item.title,
                    title: item.title,
                    quantity: (item.quantity || 0).toString(),
                    category: '',
                    brand: '',
                    price: item.variant?.price?.amount || '0',
                    position: index + 1,
                    variant: item.variant?.title || '',
                    list: location.pathname,
                    image: item?.thumbnail?.url || '',
                })) || [];

            window.analytics &&
                window.analytics.viewCart(
                    checkout?.subtotalPrice
                        ? checkout.subtotalPrice.amount
                        : '0.0',
                    cartViewItems
                );
        }
    }, [isCartOpen, lineItems]);

    const goToCheckout = () => {
        // Check if checkout has items
        if (!checkout.lineItems || checkout.lineItems.length === 0) {
            console.error('Cannot checkout: cart is empty');
            return;
        }

        window.analytics && window.analytics.initiateCheckout();

        // Use checkoutUrl from the Storefront API
        const checkoutURL = checkout.checkoutUrl || checkout.webUrl;

        if (checkoutURL) {
            console.log('Redirecting to Shopify checkout:', checkoutURL);
            window.open(checkoutURL, '_self');
        } else {
            console.error('No checkout URL found. Please refresh and try again.');
        }
    };

    return (
        <React.Fragment>
            <aside
                className={classNames('cart__modal pf pt2 pl3 pr3 df fdc', {
                    open: isCartOpen,
                    // 'banner-open': enableBanner,
                })}
            >
                <header className="cart__header df ais jcb ">
                    <p className="serif--38">Cart</p>
                    <button
                        className="cart__close mono--13 uppercase"
                        onClick={() => setCartOpen(false)}
                    >
                        Close
                    </button>
                </header>
                {lineItems.length > 0 ? (
                    <React.Fragment>
                        <section className="cart__content df fdc ofy--scroll">
                            {lineItems.map((item, index) => {
                                const productObject = {
                                    id: item.id,
                                    product_id: item.id,
                                    variant_id: item.variant?.id || '',
                                    name: item.title,
                                    title: item.title,
                                    quantity: (item.quantity || 0).toString(),
                                    category: '',
                                    brand: '',
                                    price: item.variant?.price?.amount || '0',
                                    position: index + 1,
                                    variant: item.variant?.title || '',
                                    list: location.pathname,
                                    image: item?.thumbnail?.url || '',
                                };

                                const onHandleClick = () => {
                                    window.analytics &&
                                        window.analytics.removeFromCart(
                                            location,
                                            productObject
                                        );
                                };

                                return (
                                    <article
                                        className="cart__product df mt2 pt2 bt--black-tint pt3--lg mt3--lg"
                                        key={item.id}
                                    >
                                        <section className="cart__image">
                                            <div className="img--square">
                                                {item?.variant?.image && (
                                                    <img
                                                        alt={item.title}
                                                        className="img--multiply x"
                                                        src={`${item.variant.image.src}?w=600&auto=format`}
                                                    />
                                                )}
                                            </div>
                                        </section>
                                        <section className="cart__product-desc df fdc pl2 pl3--lg">
                                            {item.vendor && (
                                                <p className="mono--13 color--black-tint">
                                                    {item.vendor}
                                                </p>
                                            )}
                                            <p className="serif--22">
                                                {item.title}
                                            </p>
                                            {item.variant.selectedOptions[0]
                                                .value !== 'Default Title' && (
                                                <p className="mono--11 mono--13--lg uppercase mt1">
                                                    {
                                                        item.variant
                                                            .selectedOptions[0]
                                                            .name
                                                    }
                                                    :
                                                    <span className="color--black-tint">
                                                        {
                                                            item.variant
                                                                .selectedOptions[0]
                                                                .value
                                                        }
                                                    </span>
                                                </p>
                                            )}

                                            <div className="df jcb cart__product-controls pt1 pt0--lg">
                                                <div className="cart__price pb1 pb0--lg">
                                                    <p className="mono--11 mono--13--lg uppercase color--black-tint">
                                                        Price
                                                    </p>
                                                    <p className="serif--22">
                                                        $
                                                        {(
                                                            Number(
                                                                item.variant
                                                                    .price
                                                                    .amount
                                                            ) * item.quantity
                                                        ).toFixed(2)}
                                                    </p>
                                                </div>

                                                <div className="cart__quantity-buttons quantity-selector quantity-selector--cart df jcb aic x">
                                                    <button
                                                        className="mono--11 mono--13--lg"
                                                        onClick={() => {
                                                            updateQuantityInCart(
                                                                item.id,
                                                                item.quantity -
                                                                    1
                                                            );
                                                            onHandleClick();
                                                        }}
                                                    >
                                                        –
                                                    </button>
                                                    <p className="mono--11 mono--13--lg">
                                                        {item.quantity}
                                                    </p>
                                                    <button
                                                        className="mono--11 mono--13--lg"
                                                        onClick={() =>
                                                            updateQuantityInCart(
                                                                item.id,
                                                                item.quantity +
                                                                    1
                                                            )
                                                        }
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </section>
                                    </article>
                                );
                            })}
                        </section>
                        <footer className="cart__footer bt--black-tint pt1">
                            <div className="cart__subtotal df jcb x">
                                <p className="serif--22">
                                    Subtotal
                                    <small className="db mono--11 mono--13--lg uppercase color--black-tint col c6--lg mt1">
                                        Your shipping costs will be calculated
                                        at checkout
                                    </small>
                                </p>
                                <p className="serif--22">
                                    $
                                    {checkout.subtotalPrice.amount.replace(
                                        '.0',
                                        '.00'
                                    )}
                                </p>
                            </div>
                            <button
                                className="button--checkout button--primary mono--11 mono--13--lg uppercase db mt2 mb2 x tc klaviyo"
                                onClick={goToCheckout}
                            >
                                Proceed to checkout
                            </button>
                        </footer>
                    </React.Fragment>
                ) : (
                    <section className="cart__empy bt--black-tint mt3 pt3">
                        <p className="serif--22">
                            Your cart is currently empty.
                        </p>

                        <Link
                            className="button--primary db mt3 mt5--lg tc"
                            to="/"
                            onClick={() => setCartOpen(!isCartOpen)}
                        >
                            Continue Shopping.
                        </Link>
                    </section>
                )}
            </aside>

            <div
                className={classNames(
                    'cart__underlay pf fill top bottom left right',
                    {
                        open: isCartOpen,
                    }
                )}
                onClick={() => setCartOpen(false)}
            />
        </React.Fragment>
    );
};

export default Cart;
